import { AuthState } from 'contexts/Auth';

export const getAuthHeader = (auth: AuthState): string | undefined => {
  if (!auth.token || auth.type === 'none') {
    return;
  }

  return `Bearer ${auth.token}`;
};

export const setAuthHeader = (headers: Record<string, string>, auth: AuthState) => {
  const authHeader = getAuthHeader(auth);

  if (!authHeader) {
    return headers;
  }

  return {
    ...headers,
    Authorization: authHeader,
  };
};
